import moment from 'moment';

export function Invoice(data) {
  this.payments = [];
  this.exportErrors = [];

  if (data) {
    if (data.billingErrors) {
      try {
        var billingErrors = JSON.parse(data.billingErrors);
        if (billingErrors.length > 0) {
          billingErrors.map(error => {
            if (error.code === 11039) {
              this.exportErrors.push(error);
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    angular.extend(this, data);
  }

  if (this.date && typeof this.date === 'string')
    this.date = new moment(this.date.substr(0, 10)).toDate();

  if (this.expiryDate && typeof this.expiryDate === 'string')
    this.expiryDate = new moment(this.expiryDate.substr(0, 10)).toDate();

  this.dueAmount = function() {
    if (this.amount < 0 && this.isInvoice) {
      return this.amount + this.paidAmount;
    }
    if (this.amount < 0 && this.paidAmount < 0 && !this.isInvoice) {
      return this.amount - this.paidAmount;
    }
    if (this.paidAmount < 0 && !this.isInvoice) {
      return this.amount + this.paidAmount;
    }

    return this.amount - this.paidAmount;
  };

  this.hasErrors = function() {
    if (this.exportErrors.length) return true;
    return false;
  };
}
